<template>
  <div class="knowledge">

    <div :class="[isMobile ? 'news-title-mobile' : 'news-title']">
      <label :class="[isMobile ? 'news-msg-mobile' : 'news-msg']">山東歷史文化知多D</label>
    </div>

    <div class="knowledge-list" v-if="!isMobile">

      <div v-for="(item, index) in knowledge_list" :key="index">

        <div class="knowledge-item" v-if="index % 2 == 0"  @click="choose(item)">
          <img class="knowledge-img" style="margin-right:40px" :src="item.cover">
          <div class="right-content">
            <div>
              <label style="font-size:28px;color:#301E03;cursor: pointer;">{{ item.title }}</label>
              <label style="font-size:16px;color:#A05200;margin-left: 12px;">{{ item.description }}</label>
            </div>

            <div v-html="item.contentShort" class="item-content-html" >
            </div>

          </div>
        </div>

        <div class="knowledge-item" v-else  @click="choose(item)">

          <div class="right-content">
            <div>
              <label style="font-size:28px;color:#301E03;cursor: pointer;">{{ item.title }}</label>
              <label style="font-size:16px;color:#A05200;margin-left: 12px;">{{ item.description }}</label>
            </div>

               <div v-html="item.contentShort" class="item-content-html" >
            </div>
          </div>

          <img class="knowledge-img" style="margin-left:40px" :src="item.cover">
        </div>


      </div>

    </div>

    <div class="knowledge-list-mobile" v-else>

      <div v-for="(item, index) in knowledge_list" :key="index" >
        <img class="knowledge-img"  :src="item.cover">
        <div style="font-size:28px;color:#301E03;margin-top: 10px;">{{ item.title }}</div>
        <div style="font-size:16px;color:#A05200;margin-top: 10px;">{{ item.description }}</div>
        <div v-html="item.content" class="item-content-html" style="font-size:16px;color:#301E03;margin-top: 0px;margin-bottom:60px;">
            </div>
      </div>
    </div>
  </div>
</template>


<script>

export default {
  name: 'Knowledge',
  data() {
    return {
      knowledge_list: [],
      isMobile: false
    }
  },
  created() {
    this.isMobile = window.isMobile
  },
  mounted() {
    var that = this;

    this.$axios.get("article/lists", { params: { cateId: "12" } }).then(function (response) {
    //  console.log('lists ' + JSON.stringify(response.data.data));
      that.knowledge_list = response.data.data

      let newList = [];
      that.knowledge_list.forEach((item)=>{

            item.contentShort = item.content.replace(/<img.*?>/g ,'');
           newList.push(item)

      })
      that.knowledge_list =newList
    }, function (err) {
      console.log('errerrerrerrerr ' + err);
    });
  },
  methods: {
    choose(item) {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
      this.$router.push({ name: 'detail', params: { type: "knowledge", data: item, } });
    },
  },
}
</script>


<style lang="scss" rel="stylesheet/scss" scoped>
.knowledge {
  flex-direction: column;
  display: flex;
  box-sizing: border-box;
  width: 100%;
  align-items: center;



  .news-title {
    margin-top: 30px;
    width: 1040px;
    display: flex;
    justify-content: space-between;

    .news-msg {
      font-size: 28px;
      color: #301E03
    }
  }

  .news-title-mobile {
    box-sizing: border-box;
    padding-left: 20px;
    margin-top: 20px;
    width: 100%;
    display: flex;
    justify-content: space-between;

    .news-msg-mobile {
      font-size: 22px;
      color: #301E03
    }
  }

  .knowledge-list {
    width: 1040px;
    margin-top: 30px;
    display: flex;
    display: -webkit-flex;
    flex-direction: column;

    .knowledge-item {
      cursor: pointer;
      align-items: center;
      height: 240px;
      margin-bottom: 88px;
      width: 100%;
      box-sizing: border-box;
      display: flex;


      .knowledge-img {
        width: 360px;
        height: 240px;
        border-radius: 8px;
      }

      .right-content {
        cursor: pointer;
        width: 640px;
      }

      .item-content-html{
        font-size:16px;
        color:#301E03;
        margin-top: 16px;

        cursor: pointer;
        overflow: hidden;
        line-height: 22px;
        text-overflow:ellipsis;
        display:-webkit-box;
        -webkit-box-orient:vertical;
        -webkit-line-clamp:7;
      }
    }
  }


  .knowledge-list-mobile{
    padding: 0px 20px;
    box-sizing: border-box;
    width: 100%;
    margin-top: 20px;
    margin-bottom: 24px;
    display: flex;
    display: -webkit-flex;
    flex-direction: column;

    .knowledge-img {
        width: 100%;
        border-radius: 8px;
      }
  }



}
</style>
